import { apiEndpoints } from 'api'
import { commonAttributes } from 'app/config'

export const columns = [
  {
    ...commonAttributes.uuid
  },
  {
    ...commonAttributes.standard,
    label: 'Grades',
    apiOptions: {
      method: 'get',
      url: `${apiEndpoints.standard}?include_is_range=true`
    }
  }
]
